import { darken, styled } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';


export const IconSearchCustom = styled(SearchIcon)(({theme}) => ({
  color: darken(theme.palette.secondary.main, 0.1),
}))
